export enum UploadStatus {
  Started,
  InProgress,
  Finished,
  Error,
}
